import { useQuery } from '@tanstack/react-query'
import { getUserProfile } from '../api/userApi'

/**
 * Hook для получения профиля текущего аутентифицированного пользователя
 *
 * Возвращает полную информацию о пользователе:
 * - referralKey - уникальный реферальный ключ
 * - tvl - Total Value Locked
 * - unclaimedVoteCount - количество невостребованных голосов
 * - бонусные награды
 * - и другие данные профиля
 *
 * @param enabled
 * @param walletAddress - адрес кошелька пользователя (для кеширования)
 */
export const useUserProfile = (
  walletAddress: string | null | undefined,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['userProfile', walletAddress],
    queryFn: getUserProfile,
    // Only fetch when both authenticated AND wallet is connected
    // This prevents 401 errors during disconnect when wallet becomes null
    // before authenticated state is updated
    enabled,
    staleTime: 1000 * 60 * 5, // 5 минут - профиль редко меняется
    gcTime: 1000 * 60 * 30, // 30 минут в кэше
    refetchInterval: 1000 * 5, // Рефеч каждые 5 секунд, как у боксов
  })
}
